export const hasToken = ({ token }) => !!token;
export const GetUser = ({ user }) => user;
